export default "__VITE_ASSET__jVkMIsXF__"